import L from 'leaflet';
import { Endpoints, UI_IDS } from './config.js';

export class MapAPI {
    constructor(mapComponent) {
        this.app = mapComponent;
    }

    async fetchWPLocations(lang = 'el') {
        try {
            const response = await fetch(`${Endpoints.wpLocations}?language=${lang}`);
            const data = await response.json();
            
            this.app.wpMarkers.clearLayers();

            const features = data.features || data; 

            features.forEach(feature => {
                const props = feature.properties || feature;
                const lat = feature.geometry ? feature.geometry.coordinates[1] : (feature.lat || props.lat);
                const lng = feature.geometry ? feature.geometry.coordinates[0] : (feature.lng || props.lng);

                if (!lat || !lng) return;

                let iconSize = 24; // Default small
                if (props.categories != null && String(props.categories).trim() !== "") {
                    // Normalize to string in case it's an array or number, then split by spaces or commas
                    const cats = String(props.categories).split(/[\s,]+/);
                    
                    // Add any other category IDs that should be "Big" to this array
                    const bigCategoryIds = ["215", "213"]; 
                    
                    if (cats.some(cat => bigCategoryIds.includes(cat))) {
                        iconSize = 48; // Big
                    } else {
                        iconSize = 36; // Intermediate
                    }
                }

                const markerOptions = {};
                if (props.mapicon) {
                    markerOptions.icon = L.icon({
                        iconUrl: props.mapicon,
                        iconSize: [iconSize, iconSize],
                        iconAnchor: [iconSize / 2, iconSize],
                        popupAnchor: [0, -iconSize]
                    });
                }
                
                const marker = L.marker([lat, lng], markerOptions);
                
                const title = props.title || props.name || '';
                const imageHtml = props.featured_image ? `<img src="${props.featured_image}" style="width:100%; max-width:200px; height:auto; margin-top:5px; border-radius:4px;"/>` : '';
                const linkHtml = props.website ? `<br/><a href="${props.website}" target="_blank">${this.app.t.visitWebsite}</a>` : '';
                
                marker.bindPopup(`
                    <div style="text-align:center; min-width: 150px;">
                        <strong>${title}</strong>
                        ${imageHtml}
                        ${linkHtml}
                    </div>
                `);

                marker.feature = feature;
                this.app.wpMarkers.addLayer(marker);
            });
        } catch (error) {
            console.error('Error fetching WP POIs:', error);
        }
    }

    fetchPanoramas() {
        if (!this.app.pano || typeof this.app.pano.getNodeIds !== 'function') {
            console.warn("Pano2VR engine does not support getNodeIds() yet or not loaded.");
            return;
        }

        this.app.panoMarkers.clearLayers();
        const nodeIds = this.app.pano.getNodeIds();

        nodeIds.forEach(nodeId => {
            const userData = this.app.pano.getNodeUserdata(nodeId);
            
            if (userData && userData.latitude && userData.longitude) {
                const lat = parseFloat(userData.latitude);
                const lng = parseFloat(userData.longitude);

                if (isNaN(lat) || isNaN(lng) || (lat === 0 && lng === 0)) return;
                
                // Determine if it's an aerial node or historical
                let isAerial = false;
                let isHistorical = false;
                if (userData.tags) {
                    if (Array.isArray(userData.tags)) {
                        isAerial = userData.tags.includes('aerial');
                        isHistorical = userData.tags.includes('historical');
                    } else if (typeof userData.tags === 'string') {
                        isAerial = userData.tags.toLowerCase().includes('aerial');
                        isHistorical = userData.tags.toLowerCase().includes('historical');
                    }
                }
                
                // Exclude historical panoramas from map
                if (isHistorical) return;
                
                const marker = L.circleMarker([lat, lng], {
                    radius: isAerial ? 12 : 7,
                    fillColor: isAerial ? '#2196F3' : '#4CAF50', // Blue for aerial, Green for normal
                    color: '#333333',
                    weight: 2,
                    opacity: 1,
                    fillOpacity: 0.9
                });
                
                marker.on('click', () => {
                    this.app.pano.openNext(`{${nodeId}}`);
                    document.getElementById(UI_IDS.modalId).classList.add('hidden'); // Close modal
                });

                marker.node_id = String(nodeId);
                marker.is_aerial = isAerial;
                this.app.panoMarkers.addLayer(marker);
            }
        });

        this.app.events.updateCurrentNodeMapVisibility();
    }
}